



































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import entries from 'lodash/entries'

import { User } from '../../store/user/types'
import FeatureType from '../../lib/masters/FeatureType'
import Feature from '../../lib/masters/Feature'
import SpecialtyType from '../../lib/masters/SpecialtyType'
import Specialty from '../../lib/masters/Specialty'
import { UserSearchFormParams } from '../../type'

@Component
export default class UserSearchForm extends Vue {
  @Prop({ default: () => [] }) users!: User[]
  @Prop({ default: '結果を表示' }) submitText!: string
  @Prop() initialParams!: UserSearchFormParams

  valid = true
  word = ''
  specialtyTypes: SpecialtyType[] = []
  featureTypes: FeatureType[] = []

  featuresRules = [
    (v: string) => v.length <= 3 || '選択できる特徴は3つまでです'
  ]

  get features() {
    return entries(Feature).map(([key, obj]) => ({
      text: obj.text,
      value: key
    }))
  }

  get specialties() {
    return entries(Specialty).map(([key, obj]) => ({
      text: obj.text,
      value: key
    }))
  }

  mounted() {
    if (this.initialParams) {
      this.word = this.initialParams.word
      this.specialtyTypes = this.initialParams.specialtyTypes
      this.featureTypes = this.initialParams.featureTypes
    }
  }

  @Watch('word')
  @Watch('specialtyTypes')
  @Watch('policyTypes')
  @Watch('featureTypes')
  handleChangeParams() {
    const params: UserSearchFormParams = {
      word: this.word,
      specialtyTypes: this.specialtyTypes,
      featureTypes: this.featureTypes
    }
    this.$emit('change', params)
  }

  handleSubmit() {
    if (!(this.$refs.searchForm as HTMLFormElement).validate()) return
    const params: UserSearchFormParams = {
      word: this.word,
      specialtyTypes: this.specialtyTypes,
      featureTypes: this.featureTypes
    }
    this.$emit('submit', params)
  }
}
